export default __webpack_public_path__ + "static/media/WalletConnector.304e3277.svg";